module.exports = __webpack_public_path__ + "static/media/RUR_lime.ab094de9.csv";